import routes from './routes';

export const ROUTES = routes;
